import SafeHtml from './SafeHtml'

const LABELS = ['A', 'B', 'C', 'D']

export default function AnswerButton({ index, text, state, disabled, onClick }) {
  const base = 'w-full flex items-start gap-3 px-4 py-3 [@media(max-height:700px)]:py-2 rounded-2xl border-2 text-left font-medium transition-all active:scale-95 disabled:cursor-not-allowed'
  const styles = {
    null:     'border-white/20 bg-white/10 text-white hover:bg-white/20',
    selected: 'border-white/80 bg-white/35 text-white ring-2 ring-white/40',
    correct:  'border-green-400 bg-green-500/30 text-white',
    wrong:    'border-red-400 bg-red-500/30 text-white/70 line-through',
    reveal:   'border-green-400 bg-green-500/20 text-white',
  }
  return (
    <button onClick={onClick} disabled={disabled} className={`${base} ${styles[state ?? 'null']}`}>
      <span className="shrink-0 w-6 h-6 rounded-full bg-white/20 flex items-center justify-center text-xs font-semibold">
        {LABELS[index]}
      </span>
      <SafeHtml html={text} className="text-sm leading-snug" />
    </button>
  )
}
